module.exports = __webpack_public_path__ + "media/images/element/primary-school-4211b4c28012926fecc8035c6d1ea00e.svg";